import { type KnackViewType } from '@/types/schema/BuilderView';

// TODO: eventually implement the subflows for adding ecommerce views
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function AddEcommerceViewFlow({ selectedViewType }: { selectedViewType: KnackViewType }) {
  return <div>Subflow for adding Ecommerce views</div>;
}
